import api from "../config/http-common";

const addVideo = (payload) => {
  return api.securedAxios().post("/web/safety-videos", payload);
};

const getSafetyVideo = (payload) => {
  return api.securedAxios().get("/web/safety-videos");
};

const getCompanySafetyVideo = (payload) => {
  return api.unsecuredAxios().get("/web/safety-videos/" + payload.companyId);
};

const updateSafetyVideo = (payload) => {
  return api
    .securedAxios()
    .put("/web/safety-videos/" + payload.get("id"), payload);
};

const SafetyVideoService = {
  addVideo,
  getSafetyVideo,
  getCompanySafetyVideo,
  updateSafetyVideo,
};

export default SafetyVideoService;
